import React, { Component } from "react";
import MultiCarousel from "../MultiCarouselElements/MultiCarousel";
import MultiCarouselArrows from "../MultiCarouselElements/MultiCarouselArrows";
import ItemScrollProduct from "../ItemScrollProduct";

class ProductScroll extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            isMounted: false,
        };

        let responsive = {
            desktop: {
                breakpoint: { max: 9999, min: 1024 },
                items: 2,
                slidesToSlide: 2,
                partialVisibilityGutter: 0
            },
            tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 2,
                slidesToSlide: 2,
                partialVisibilityGutter: 0
            },
            mobile: {
                breakpoint: { max: 464, min: 0 },
                items: 1,
                slidesToSlide: 1,
                partialVisibilityGutter: 120
            }
        };
    
        const showNextItem = this.props.items.length > 1;
    
        this.settings = {
            swipeable: true,
            draggable: false,
            showDots: false,
            responsive: responsive,
            containerClass: `${this.props.cssBlock}__slider-container`,
            itemClass: `${this.props.cssBlock}__slider-item`,
            keyBoardControl: true,
            infinite: false,
            arrows: false,
            customButtonGroup: <MultiCarouselArrows cssBlock={this.props.cssBlock} color={this.props.color} buttonColor={this.props.buttonColor} />,
            renderButtonGroupOutside: true,
            partialVisible: showNextItem
        }
    }
    

    componentDidMount() {
        if (this.props.items) {
            this.setState({
                isMounted: true,
                items: [...this.props.items],
            });
        }
        if (this.props.settings) {
            this.settings = this.props.settings;
        }
    }
    children = (items, color, buttonColor) => {
        return (
            items.map((item, index) => (
                <ItemScrollProduct item={item} key={index} color={color} buttonColor={buttonColor}/>
            ))
        )
    };

    render() {
        const { link, linktext, items, cssBlock, color, buttonColor, hasBackgroundColor } = this.props;
        return (
            <div id="product-list-block" className={`item-scroll`}>
                {this.state.isMounted && (
                    <MultiCarousel settings={this.settings} children={this.children(items, color, buttonColor)} items={items} cssBlock={cssBlock} color={color} buttonColor={buttonColor}/>
                )}
                {link && linktext &&
                    <a href={link} className="item-scroll__link" style={{ color: color }}>{linktext}</a>
                }
            </div>
            
        );
    }
    
}
export default ProductScroll;
